import RegionDescription from './RegionDescription';

export default RegionDescription;
